import React from "react";

import Tooltip from "core/ui-kit/tooltip";
import Icon from "core/ui-kit/icon";

const FormLabel = ({
	isRequired=false,
    tooltip,
    label
}) => {

    if(!label){
        return label;
    }

	const builtLabel = isRequired ? `${label} *` : label;

    if(!tooltip){
        return builtLabel;
    }

	return (
        <div className="rt--flex rt--align-center">
            { builtLabel }
            <Tooltip
                title={tooltip}
                trigger={["hover", "click"]}
                placement="bottomLeft"
                enableMobile={true}
            >
                <Icon name='info' size={14} className="rt--ml-6" />
            </Tooltip>
        </div>
    )
};

export default FormLabel;
